import React, { useContext } from 'react';
import styles from './ReportSectionSelectListOption.module.scss';
import { Customer, CustomerContext } from 'ui-smartforce-settings';
import { formatDate } from '../../../../../../Helpers';
import {
  StatusChip,
  StatusChipProps
} from '../../../../../ReportChips/StatusChip/StatusChip';
import { ReportableChip } from '../../../../../ReportChips/ReportableChip/ReportableChip';

export interface ReportSectionSelectListOptionProps {
  incidentDate: string;
  sectionName: string;
  isSelected: boolean;
  statusChips?: StatusChipProps;
  onClick: () => void;
}

export const ReportSectionSelectListOption = ({
  incidentDate,
  sectionName,
  isSelected,
  statusChips,
  onClick
}: ReportSectionSelectListOptionProps): React.ReactElement<ReportSectionSelectListOptionProps> => {
  const timezone = (useContext(CustomerContext).customer as Customer).timezone;

  const onKeyUp = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter') {
      onClick();
    }
  };

  return (
    <li
      className={`${styles.reportSectionSelectListOption} ${
        isSelected ? styles.isSelected : ''
      }`}
      role="menuitem"
      onClick={onClick}
      onKeyUp={onKeyUp}
    >
      <div className={styles.listOptionLabel}>
        <p className={styles.labelDate}>{sectionName}</p>
        <p className={styles.labelAuthor}>
          {formatDate(incidentDate, 'L - HH:mm', timezone)}
        </p>
        {statusChips && (
          <div className={styles.statusChips}>
            <ReportableChip
              isReportable={statusChips.isReportable}
              size="tiny"
            />
            <StatusChip
              isReportable={statusChips.isReportable}
              status={statusChips.status}
              size="tiny"
            />
          </div>
        )}
      </div>
    </li>
  );
};
